import { create } from 'zustand';

import { IS_WHITE_LABEL } from '@/shared/environments';

import { DEFAULT_BALANCE } from '../lib/defaultBalance';
import { getBalance } from '../lib/getBalance';
import { getUploadGate } from '../lib/getUploadGate';
import { BalanceStore, BalanceStoreActions } from '../lib/types';

const hasEnoughMinutesToDubSelector = (state: BalanceStore, projectDuration?: null | number) => {
  if (!projectDuration) {
    return false;
  }

  return state.availableMinutes >= Math.ceil(projectDuration / 60);
};

export const createBalanceStore = () => {
  const useBalanceStore = create<BalanceStore & BalanceStoreActions>((set) => ({
    ...DEFAULT_BALANCE,

    resetBalance: () => set({ ...DEFAULT_BALANCE }),

    setBalance: (balance) =>
      set(() => ({
        ...getBalance(balance),
        isBalanceLoaded: true,
      })),

    updateBalance: (updatedBalance) =>
      set((state) => {
        const { planName } = updatedBalance;

        if (!planName) {
          return {
            ...updatedBalance,
            planName: state.hasFreeSubscription || state.hasTrialPlan ? 'Free Plan' : 'Archive Plan',
          };
        }

        return updatedBalance;
      }),
  }));

  const useHasEnoughMinutesToDub = (projectDuration?: null | number) => {
    return useBalanceStore((state) => hasEnoughMinutesToDubSelector(state, projectDuration));
  };

  const useUploadGate = () => getUploadGate(useBalanceStore(), IS_WHITE_LABEL);

  return { useBalanceStore, useHasEnoughMinutesToDub, useUploadGate };
};
